let content = [
  {
    id: "general_trading_conditions",
    title: "شروط تداول عامة",
    tabs: [
      {
        //id: "product_details",
        id:"tc-view-6",
        title: "تفاصيل المنتج",
        content_before: `<p class="mb-5">
                          شركة iFOREX توفر شروطًا تنافسية للغاية للأدوات المالية التالية ("الأدوات المالية" أو "الأدوات") (1) تداول الأدوات المالية/الأصول الأساسية ("الأصول الأساسية") على الهامش او بالرافعة المالية بما في ذلك ازواج العملات (الفوركس) والسلع الاساسية والمؤشرات والأسهم والعقود مقابل الفروقات (CFD) وصناديق الاستثمار المتداولة (ETF) والعملات الرقمية المشفرة (Crypto) ("الرافعة المالية للادوات المالية" أو "العقود مقابل الفروقات"), و (2) منتجات التداول بدون الرافعة المالية.
                          <br><br>
                          <b>فارق النقاط ( السبريد)</b><br>السبريد هو تكلفة الصفقة- هو الفرق بين سعر البيع وسعر الشراء. على سبيل المثال، اذا كان سعر الصرف لزوج العملات USD/JPY في البيع 101.202 وفي الشراء السعر 101.222، فان الفرق بين السعران يسمى السبريد، في هذه الحالة السبريد (فارق النقاط) هو 2 بيبس (نقاط).
                          <br><br>
                          <b>الهامش والرافعة المالية</b><br>عند تداول الأدوات المالية بالرافعة المالية، في حين ان ‘الهامش’ يعمل كضمان لتغطية أي خسائر قد تحصل، فهو يتيح لك أيضا أن تعقد صفقة أكبر بكثير من قيمة حسابك الفعلي مما يتيح لك إمكانية تحقيق أرباح كبيرة بالنسبة إلى المبلغ المُستَثمر.
                          <br><br>
                          تعتبر الرافعة المالية سلاحًا ذو حدين، فهي من الممكن أن تزيد بشكل كبير من أرباحك ويمكن أيضًا أن تضخم خسائرك بسهولة. عند إستخدامك للرافعة المالية بشكل كبير فإن الصفقات الخاسرة قد تعادل بسرعة، الكثير من الصفقات الرابحة. بينما أن عملية التداول بإستخدام الرافعة المالية فيها نسبة عالية من المخاطر والتي قد لا تناسب جميع المستثمرين.
                          <br><br>
                          ولكونك صاحب حساب لدى iFOREX، يحق لك الحصول على برنامج الحماية ضد الرصيد السلبي لدينا، مما يعني أنه لا يمكنك أبدا أن تخسر أكثر مما قمت بإيداعه، ومع ذلك، فإن أي حركة صغيرة للسوق يمكن أن تؤدي إلى خسارة كبيرة للأموال. تقوم منصة التداول لدينا تلقائيًا بحساب متطلبات الهامش الخاصة بك قبل تنفيذ أي أمر والتحقق من مستوى رصيدك قبل تنفيذ أي طلب لسحب الأموال.
                          <br><br>
                          متطلبات الهامش متصله مع زيادة نسبة التعريض في الحساب، سواء عن طريق فتح/ إغلاق الصفقات أو عن طريق طلب سحب الأموال عند وجود صفقات مفتوحة في الحساب. تعكس متطلبات الهامش المخاطر المحتملة في الصفقات، بناء على تقلبات السوق، السيولة، وتوافر الاسعار في أي أداة معروضه ولذلك تزداد الهوامش خلال وحول فترة الإستراحة في التداول.
                          </p>
            
                          <span id="product_section"></span>
                          <p class="tc-inner-link"><a href="/شروط-التداول/العملات">العملات</a></p>
                          <p class="tc-inner-link"><a href="/شروط-التداول/السلع">السلع</a></p>
                          <p class="tc-inner-link"><a href="/شروط-التداول/المؤشرات">المؤشرات</a></p>
                          <p class="tc-inner-link"><a href="/شروط-التداول/الاسهم">الاسهم</a></p>
                          <p class="tc-inner-link"><a href="/شروط-التداول/سلة-الأصول">سلة-الأصول</a></p>
                          <p class="tc-inner-link"><a href="/شروط-التداول/العملات-الافتراضية">العملات الافتراضية</a></p>
                          <p class="tc-inner-link"><a href="/شروط-التداول/المنتجات-بدون-الرافعة-المالية">المنتجات بدون الرافعة المالية</a></p>`,

        data_id: "",
        content_after: "",
      },
      {
        //id: "trading_hours",
        id: "tc-view-2",
        title: "ساعات التداول",
        content_before: `<p class="mb-4">
        خلال فصل الشتاء في أوروبا وأمريكا الشمالية، يبدأ النشاط الأسبوعي يوم الأحد في الساعة 22:05 بتوقيت جرينتش ويستمر حتى يوم الجمعة الساعة 21:00 بتوقيت جرينتش. خلال التوقيت الصيفي في هذه المناطق، يبدأ نشاط السوق الأسبوعي يوم الأحد في الساعة 21:05 بتوقيت جرينتش وينتهي يوم الجمعة في الساعة 20:00 بتوقيت جرينتش. قد تختلف ساعات النشاط في السوق بسبب العطلات العامة أو نتيجة لظروف السيولة الغير عادية التي قد تحدث بسبب الأحداث العالمية الاستثنائية. أوقات افتتاح أو إغلاق السوق يمكن أن تتغير ايضاً من قبل شركة iFOREX بسبب اعتبارات السيولة وإدارة المخاطر.
        <br><br>
        بالرغم من أنه بالامكان تداول أغلب الادوات المالية على مدار 24 ساعة دون إنقطاع، هناك بعض الأدوات المالية التي يمكن تداولها في ساعات معينة فقط وكما هو معروض في القائمة أدناه.:
        </p>`,

        data_id: "TradingHours",
        products: {
          1:"العملات والعملات الافتراضية",
          2:"السلع",
          3:"المؤشرات",
          4:"الاسهم",
          5:"المعادن الثمينة ( سبوت)",
          8:"سلة الاصول ETFs"
        },
        table_titles: [
          "السوق",
          "ساعات التداول (بتوقيت جرنيتش)",
          "توقيت الاستراحة اليومية الأولى (بتوقيت غرينتش)",
          "توقيت الاستراحة اليومية الثانية (بتوقيت غرينتش)",
          "البيانات سارية المفعول حتى (بتوقيت جرنيتش)"
        ],
        content_after: `<p>انت غير متأكد من أي سوق تشمل الاداة المالية التي تبحث عنها؟ أنقر هنا للعرض الكامل <span class="tclink" target-tab="tc-view-6">لقائمة الادوات المالية حسب كل سوق</span>.</p>`,
      },
      {
        //id: "holidays",
        id: "tc-view-4",
        title: "العطل الرسمية والاعياد",
        content_before: `<p>
        لنتأكد أنك على بينة وعلم من كل ساعات السوق والعطل الرسمية تجد أدناه قائمة من الأحداث التي يمكن أن تغير ساعات التداول.<br>في شركة iFOREX نبذل قصارى جهدنا للحفاظ على هذه المعلومات محتلنة وباحسن حال.<br>إذا كنت ترغب في الحصول على المزيد من المعلومات لا تتردد بالاتصال والتواصل مع غرفة الصفقات.
        </p>`,

        data_id: "Holidays",
        table_titles: [
          "السوق",
          "وقف التداول في (بتوقيت جرنيتش)",
          "استئناف التداول في (بتوقيت جرنيتش)",
        ],
        content_after: `<p class="mt-4">انت غير متأكد من أي سوق تشمل الاداة المالية التي تبحث عنها؟ أنقر هنا للعرض الكامل <span class="tclink" target-tab="tc-view-6">لقائمة الادوات المالية حسب كل سوق</span>.</p>`,
      },
      {
        //id: "orders_and_execution",
        id: "tc-view-23",
        title: "الاوامر والتنفيذ",
        content_before: `<p><b>انواع الاوامر</b></p>

            <table class="mb-4 table4">
                <tbody>
                    <tr>
                        <th>اوامر السوق</th>
                        <th></th>
                    </tr>
                    <tr>
                        <td>إفتتاح صفقة</td>
                        <td>طلب لإفتتاح صفقة بالسعر الحالي المتاح في السوق</td>
                    </tr>
                    <tr>
                    <td>إغلاق صفقة</td>
                        <td>طلب لإغلاق صفقة بالسعر الحالي المتاح في السوق</td>
                    </tr>
                </tbody>
            </table>

            <table class="mb-4 table4">
                <tbody>
                    <tr>
                        <th>اوامر الحدود</th>
                        <th></th>
                    </tr>
                    <tr>
                        <td>أيقاف الخسارة</td>
                        <td>ميزة ايقاف الخسارة هو اما طلب لفتح او اغلاق صفقة بسعر أدنى من سعر السوق الحالي</td>
                    </tr>
                    <tr>
                        <td>جنيّ الارباح</td>
                        <td>جنيّ الارباح هو اما طلب لفتح او اغلاق صفقة بسعر اعلى من سعر السوق الحالي</td>
                    </tr>
                </tbody>
            </table>

            <p>
              <b>اوامر السوق</b><br>أوامر السوق (طلبات التداول، مثال فتح صفقة، اغلاق صفقة) يتم تنفيذها على السعر الساري المفعول على منصة التداول في الشركة (جهة العميل) في وقت التنفيذ الدقيق، بشرط أن يكون هذا السعر ضمن مستوى التسامح المحدد مسبقاً من السعر الأساسي المشار إليه في خادم (سيرفر) الشركة وبغض النظر عما إذا كان السعر الأساسي هو أعلى أو أقل من السعر المشار إليه في منصة التداول (ما تراه هو ما تحصل عليه، أو ما يسمى WYSIWYG- What You See Is What You Get). في حالة أن السعر الظاهر في منصة التداول (جهة العميل) يتجاوز مستوى التسامح أعلاه، على سبيل المثال بسبب التغيرات في سعر الأصول الأساسية بين الوقت الذي وضع فيه العميل الامر (الطلب) والوقت الذي تم استقباله وتنفيذه، التقلبات العالية في الأسواق والتأخير في الاتصالات، سيتم تنفيذ الأمر بالسعر المشار إليه في خادم الشركة الذي يجب أن يكون مختلفاً عن السعر المشار إليه في منصة التداول (سعر السوق)، على أساس متناظر\\متماثل. في حال وجود فارق كبير بين السعر الظاهر في منصة التداول (جهة العميل) والسعر المشار اليه في سيرفيرات (خوادم) الشركة، يجب ان يتم رفض الطلب.
          </p>
          <p>
          <b>اوامر الحدود</b><br>يتم تنفيذ أوامر الحودد (الأوامر المستقبلية) بسعر السوق المشار اليه في سيرفر (خادم) الشركة الذي قد يكون مختلفاً عن السعر المشار إليه في الأمر ("عملية انزلاق بالسعر"). قد يحدث الانزلاق في حالة التي يكون بها السعر الظاهر في النظام غير متوفر في السيرفر (الخادم)، على سبيل المثال، بسبب ارتفاع معدل التذبذب والفجوات في أسعار السوق. في هذه الحالة، سيتم تنفيذ الأمر في أول سعر متاح، بغض النظر عن اتجاه الانزلاق، إما لصالح العميل أو لغير صالحة، بأسلوب منهجي وشفاف (متساوي للانزلاق).<br><br>الأدوات المالية التي لا يتم تداولها على أساس 24 ساعة يومياً،(على سبيل المثال الأسهم، المؤشرات، العقود مقابل الفروقات وصناديق الاستثمار المتداولة في البورصة)، قد تواجه في السوق فجوة\\ثغرة على أساس يومي، وبالتالي فهي أكثر عرضة للانزلاق. من المهم أن نشير الى أن الانزلاق لا يؤثر على الحماية من الرصيد السلبي وبالتالي فإن العميل لن يخسر أبداً أكثر من المبلغ الذي استثمره (بما في ذلك أي ربح، إذا حققه)، حتى في حالة حدوث الانزلاق.
          </p>
          <p>
          <b>تأخير في التنفيذ</b><br>قد يحدث تأخير في التنفيذ لأسباب مختلفة، مثل مسائل تقنية في الإنترنت لدى العميل أو الموبايل أو غيرها من وسائل الاتصال إلى خوادم (سيرفيرات) شركة iFOREX، مما قد يؤدي إلى حدوث "أوامر معلقة". اذا كان هناك اضطراب في الاتصال، في بعض الأحيان يكون اضطراب في الإشارة وبسبب ذلك يتم تعطيل المنصة وهذا يسبب تأخير في نقل البيانات بين منصة المتداول والخادم (سيرفر) في شركة iFOREX.
          </p>
          <p>
          <b>أوامر معلقة</b><br>خلال فترات أحجام التداول الكثيفة أو تأخير في الاتصالات قد يحصل ما يسمى بالأوامر المعلقة (قائمة انتظار في أوامر الحدود). هذه الزيادة في أوامر الحدود الوافدة في بعض الأحيان قد تخلق ظروفاً حيث يكون هناك تأخير في تأكيد/معالجة أوامر الحدود المعينة. في بعض الحالات قد يكون تم تنفيذ هذا الصفقة وفي الواقع التأخير ببساطة هو في العرض من جانب العميل بسبب التاخير في استجابة الإنترنت.<br><br>تذكر أنه من الضروري إدخال أي أمر مرة واحدة فقط. إدخال عدة مرات الأمر نفسه قد تبطئ أو تقفل جهاز الكمبيوتر الخاص بك، أو عن غير قصد سيتم فتح مراكز وصفقات غير مرغوب فيها.
          </p>`,

        data_id: "",
        content_after: "",
      },
      {
        //id: "negative_balance_protection",
        id: "tc-view-20",
        title: "الحماية من الرصيد السلبي",
        content_before: `<p>
        تضمن سياسة حماية الرصيد السلبي في شركة iFOREXعلى أن تقتصر خسائر العميل على الأموال المستثمرة في حساب العميل. وفقاً لهذه السياسة، العميل لن يواجه رصيد مديون بسبب الخسائر الناتجة من التداول في شركة iFOREX والخسارة المحتملة للعميل تقتصر على الأموال التي تم ايداعها في حساب العميل والأموال المكتسبة من قبل العميل إن وجدت فقط.</p>`,
        data_id: "",
        content_after: "",
      },
      {
        //id: "bonus_terms_and_conditions",
        id:'btc',
        title: "شروط واحكام البونوص",
        content_before: `
        <p><b>المقدمة</b><br>هذه الشروط والأحكام للبونوص تخص بونوص التداول، كذلك البونوص الترحيبي , بونوص الاسترجاع النقدي (كاش-باك) وبونوص الحساب التجريبي التي تقدمها الشركة (وتسمى فيما يلي "البونوص")، كما هو مفصل أدناه، وتعتبر جزءاً لا يتجزأ من شروط واحكام الشركة . كل تفسير تشمله هذه الوثيقة، هي كما تم تفصيله في شروط وأحكام الشركة، الموجودة في موقع الشركة <a href="/">www.iforexarab.com</a>.</p>
        <p>
        <b>شروط الاحقية</b><br>تتوفر المكافآت (البونوص) لعملاء الشركة الذين يستوفون معايير الأهلية للعرض ذي الصلة ، ويجتازون جميع إجراءات التسجيل المطلوبة وفقًا لمتطلبات الشركة كما يتم تعديلها من وقت لآخر وفقًا لتقدير الشركة وحدها ، ويتم اعتمادها من قبل الشركة كعملاء مؤهلين ("<b>العملاء المؤهلون</b>").
        <br><br>
        أي بونوص تقدمه الشركة يتم وفقاً لتقديرها المطلق، إلى اي عميل و/أو بلد/منطقة بالشكل الذي تراه مناسباً.
        <br><br>
        تحتفظ الشركة بحقها وحسب تقديرها الخاص برفض تسجيل أي مستخدم، بما في ذلك عملاء مستحقين، الى البونوص و/أو إلغاء العرض لأي بونوص وفقاً لتقديرها المطلق.<br><br>سكان من ولايات قضائية محدودة، بما في ذلك سكان الولايات المتحدة الامريكية، غير مؤهلين للحصول على بونوص التداول.
        </p>
        <p><b>بونوص التداول</b><br>مع مراعاة الشروط العامة الواردة أدناه ، تُمنح مكافأة بونوص التداول للعملاء المؤهلين كنسبة مئوية من مبلغ الأموال المودعة في حساب التداول الخاص بهم و / أو خلاف ذلك وفق ما تراه الشركة مناسبًا حسب تقديرها الخاص.
        <br><br>
        تم تحديد بونوص التداول لأغراض التداول على الهامش فقط، وبالتالي لا يمكن استخدامها إلا كهامش إضافي (أي لن يكون العميل قادرًا على سحب البونوص الممنوح) ولا يجوز استخدامه لأغراض التداول على المنتجات المطروحة بدون رافعة مالية .
        <br><br>
        يتم منح مكافأة بونوص التداول لكل عميل مؤهل.
        <br><br>
        البونوص الترحيبي - هو بونوص للتداول للذين يقومون بالإيداع الأولي.
        </p>
        في الحالات التي يتم فيها منح بونوص للتداول عند إلايداع في الحساب ، يتم تطبيق الشروط التالية :
        <br>
        <ol>
        <li class="mb-0 mt-1">في حالة قام المتداول بسحب كافة أموال السيولة - فذلك سوف يؤدي الى إلغاء كل مبلغ بونوص التداول.</li>
        <li>في حال القيام بعملية السحب - سيتم تعديل بونوص التداول ليصبح مساوي لـــ  ٪20 من السيولة  المتبقية في الحساب بعد السحب ، أو كما تقرر الشركة بخلاف ذلك ، وفقا لتقديرها الخاص ، من وقت لآخر.</li>
        </ol>
        
        <u style="font-style:italic">مثال</u><br><br>
        يوافق العميل المستحق مع الشركة بالحصول على ٪30 بونوص على الايداع الذي قام به مبلغ 1,000$. بذلك سيحصل العميل المستحق على هامش اضافي بقيمة 300$ ( أي، ٪30 من مبلغ الايداع) كبونوص تداول.<br><br>سوف يعكس هذا البونوص على حساب العميل على النحو التالي:
        <div class="table-wrapper">
        <table class="table2 mt-4 mb-4 w-auto">
        <tbody><tr>
        <th>الرصيد</th>
        <th>السيولة</th>
        <th>الهامش المتاح</th>
        <th>بونوص التداول</th>
        </tr>
        <tr>
        <td>$1,000</td>
        <td>$1,000</td>
        <td>$1,300</td>
        <td>$300</td>
        </tr>
        </tbody></table>
        </div>
        لا يمكن سحب بونوص التداول مطلقاً. ولكن يجوز سحب الارباح التي تحققت من خلال بونوص التداول على يد العميل المستحق وفقاً لسياسة السحب ومطابقة القوانين في الشركة. الارباح المسحوبة التي تحققت من بونوص التداول سوف تعرض في قسم "الرصيد" في حساب العميل.
        
        <br><br>
        <u style="font-style:italic">مثال</u><br><br>
        يوافق العميل المستحق مع الشركة بالحصول على ٪30 بونوص على الايداع الذي قام به مبلغ 1,000$. لدى العميل المستحق السيولة والرصيد التالي في حسابه:
        <div class="table-wrapper">
        <table class="table2 mt-4 mb-4 w-auto">
        <tbody><tr>
        <th>الرصيد</th>
        <th>السيولة</th>
        <th>الهامش المتاح</th>
        <th>بونوص التداول</th>
        </tr>
        <tr>
        <td>$1,000</td>
        <td>$1,000</td>
        <td>$1,300</td>
        <td>$300</td>
        </tr>
        </tbody></table>
        </div>
        <u style="font-style:italic">سيناريو 1</u><br><br>
        طلب العميل سحب المبلغ الكامل الذي قام بإيداعه بقيمة 1,000$. سيتم الغاء بونوص التداول كاملاً.<br><br>هذا ينعكس على حساب العميل على النحو التالي:
        <div class="table-wrapper">
        <table class="table2 mt-4 mb-4 w-auto">
        <tbody><tr>
        <th>الرصيد</th>
        <th>السيولة</th>
        <th>الهامش المتاح</th>
        <th>بونوص التداول</th>
        </tr>
        <tr>
        <td>$0</td>
        <td>$0</td>
        <td>$0</td>
        <td>$0</td>
        </tr>
        </tbody></table>
        </div>
        <u style="font-style:italic">سيناريو 2</u><br><br>
        لقد قام العميل بطلب سحب مبلغ 800 دولار , مما أدى الى انخفاض السيولة الى مستوى 200 دولار , ففي هذه الحالة فان بونص التداول سوف يقتصر على ٪20 من قيمة السيولة الجديدة , أي 40 دولار.<br><br>وسوف ينعكس ذلك على حساب العميل على النحو التال:
        <div class="table-wrapper">
        <table class="table2 mt-4 mb-4 w-auto">
        <tbody><tr>
        <th>الرصيد</th>
        <th>السيولة</th>
        <th>الهامش المتاح</th>
        <th>بونوص التداول</th>
        </tr>
        <tr>
        <td>$200</td>
        <td>$200</td>
        <td>$240</td>
        <td>$40</td>
        </tr>
        </tbody></table>
        </div>
        جميع بونوصات التداول يجب ان تلغى إذا كان الحساب غير نشط لمدة 7 أسابيع متتالية.
        <br><br>
        <p><b>كاش-باك</b><br>
        برنامج الكاش-باك يمنح حساب العميل المستحق نقود بشكل اسبوعي اعتماداً ووفقاً لحجم التداول المحقق في هذا الاسبوع وتصل حتى مبلغ محدد مسبقاً من قبل الشركة ("بونوص معلق").<br><br>البونوص المعلق يمكن ان ينبع من ايداع معين او عدة عمليات ايداع، كنسبة مئوية من قيمة الايداع، او يتم تحديدها وفقاً لتقادير الشركة وحدها.
        </p>
        <u style="font-style:italic">مثال</u><br><br>
        العميل المستحق الذي قام بإيداع 1,000$ يستحق الحصول على حتى ٪40 من قيمة الايداع الذي قام به كبونوص كاش-باك لتداول بحجم تداول 20,000,000$. عميل كهذا سيحصل على 400$ بونوص معلق.<br><br>هذا البونوص المعلق (قيد الانتظار) ينعكس على حساب العميل على النحو التالي:
        <div class="table-wrapper">
        <table class="table2 mt-3 mb-4 w-auto">
        <tbody><tr>
        <th>الرصيد</th>
        <th>السيولة</th>
        <th>الهامش المتاح</th>
        <th>بونوص معلق</th>
        <th>حجم تداول محقق</th>
        <th>حجم تداول مطلوب</th>
        </tr>
        <tr>
        <td>$1,000</td>
        <td>$1,000</td>
        <td>$1,000</td>
        <td>$400</td>
        <td>$0</td>
        <td>$20,000,000</td>
        </tr>
        </tbody></table>
        </div>
        الكاش-باك المحقق كل اسبوع والذي يتم حسابه وفقاً لحجم التداول الاسبوعي الذي قام به العميل سيتم خصمه من مبلغ الكاش-باك الكلي (بونوص معلق) ويتم ايداعه في حساب العميل وفقاً للنسبة بين حجم التداول الاسبوعي الفعلي للعميل (بالدولار الامريكي) وحجم التداول المطلوب، كما هو مفصل في منصة التداول. توضيح، العميل يستحق مبلغ الكاش-باك المحقق فقط والبونوص المعلق يتم الحصول عليه فقط عند اتمام حجم التداول المطلوب. مبلغ الكاش-باك ("الكاش-باك المحقق") يقتصر على البونوص المعلق المخصص للعميل.<br><br>يتم حساب حجم التداول على اساس (الدخول والخروج)، اي ما يعني فتح صفقة 1 مليون دولار امريكي (او ما يعادلها بعملة اخرى) واغلاق نفس الصفقة، يتم اعتباره 2 مليون دولار امريكي (او ما يعادلها بعملة اخرى) كمبلغ كلي لمتطلبات حجم التداول للعميل.
        <br><br>
        <u style="font-style:italic">مثال</u><br><br>
        <u style="font-style:italic">سيناريو 1</u><br><br>
        العميل المستحق في المثال السابق، عُرض عليه تحقيق 100$ كاش-باك على تداول 5,000,000$. بعد اسبوع حقق حجم تداول 5,000,000$. بذلك استوفى العميل حجم التداول وربح 100$ كاش-باك وتم تحويلها من البونوص المعلق الى السيولة في حسابه.<br><br>هذا ينعكس على حساب العميل على النحو التالي:
        <div class="table-wrapper">
        <table class="table2 mt-4 mb-4 w-auto">
        <tbody><tr>
        <th>الرصيد</th>
        <th>السيولة</th>
        <th>الهامش المتاح</th>
        <th>بونوص معلق</th>
        <th>حجم تداول محقق</th>
        <th>حجم تداول مطلوب</th>
        </tr>
        <tr>
        <td>$1,100</td>
        <td>$1,100</td>
        <td>$1,100</td>
        <td>$300</td>
        <td>$5,000,000</td>
        <td>$20,000,000</td>
        </tr>
        </tbody></table>
        </div>
        <u style="font-style:italic">سيناريو 2</u><br><br>
        بعد اسبوعان من الايداع،حقق العميل حجم تداول 5,000,000$ وارباح بقيمة 300$. بذلك استوفى العميل حجم التداول المطلوب وربح 100$ كاش-باك اخرى وتم تحويلها من البونوص المعلق الى السيولة في حسابه.<br><br>هذا ينعكس على حساب العميل على النحو التالي:
        <div class="table-wrapper">
        <table class="table2 mt-4 mb-4 w-auto">
        <tbody><tr>
        <th>الرصيد</th>
        <th>السيولة</th>
        <th>الهامش المتاح</th>
        <th>بونوص معلق</th>
        <th>حجم تداول محقق</th>
        <th>حجم تداول مطلوب</th>
        </tr>
        <tr>
        <td>$1,500</td>
        <td>$1,500</td>
        <td>$1,500</td>
        <td>$200</td>
        <td>$10,000,000</td>
        <td>$20,000,000</td>
        </tr>
        </tbody></table>
        </div>
        بعد تحويلها الى السيولة، فان الكاش-باك الذي تم تحقيقه سيكون متاح للتداول او بامكان العميل سحبه في اي وقت. كذلك يمكن سحب اي ارباح تم تحقيقها من استخدام الكاش-باك على يد العميل المستحق.<br><br>عرض الكاش-باك لفترة زمنية محدودة، والعميل يحصل على الكاش-باك المستحق خلال اول 3 اشهر من اليوم الذي مُنح به البونوص المعلق. العميل مؤهل للمزيد من الكاش-باك عندما يقوم بإيداع اضافي.
        <br><br>
        <u style="font-style:italic">مثال</u><br><br>
        العميل المستحق في المثال السابق، قرر ان يقوم بسحب الارباح التي كانت بقيمة 300$، ومبلغ الكاش-باك الذي استحقه بقيمة 200$. بذلك قام العميل بسحب مبلغ كلي 500$. اما ما تبقى من بونوص الكاش-باك (البونوص الاولي كان 400$)، 200$ فسوف تبقى كبونوص معلق في الحساب ويستطيع العميل متابعة التداول بالمبلغ الذي قام بإيداعه 1,000$ وسيبقى لديه شهران ونصف لتحقيق حجم التداول المطلوب وتحويل البونوص من بونوص معلق الى كاش-باك مستحق.<br><br>هذا ينعكس على حساب العميل على النحو التالي:
        <div class="table-wrapper">
        <table class="table2 mt-4 mb-4 w-auto">
        <tbody><tr>
        <th>الرصيد</th>
        <th>السيولة</th>
        <th>الهامش المتاح</th>
        <th>بونوص معلق</th>
        <th>حجم تداول محقق</th>
        </tr>
        <tr>
        <td>$1,000</td>
        <td>$1,000</td>
        <td>$1,000</td>
        <td>$200</td>
        <td>$10,000,000</td>
        </tr>
        </tbody></table>
        </div>
        جميع مبالغ بونوص الكاش-باك يتم منحها بعملة الحساب الرئيسية.
        <br><br>
        <p>
        <b>حساب تجريبي</b><br>
        قد يُزوّد المستخدمين بحساب تجريبي الذي يشمل بونوص تداول (كما هو موضح أعلاه) بقيمة 25$ والذي يمكن استخدامه (وفقا لشروط التداول التابعة للشركة).
        <br><br>
        يجب ان تنتهي صلاحية الحساب التجريبي وجميع الصفقات المعلقة فيه خلال 3 ايام منذ فتح اول معاملة في الحساب التجريبي ("وجميع الصفق"). أي مبلغ سيتجاوز قيمة 25$ ("ارباح") اما ان يستخدم كهامش لحساب التداول الحقيقي الخاص بالمستخدم في الشركة و/او تداول المنتجات المطروحة للتداول بدون رافعة مالية ، وذلك رهناً لإنهاء معاملة التسجيل في الشركة بشكل ناجح وكامل وايداع مبلغ لا يقل عن 100$، او يمكن سحب المبلغ وايداعه في حساب مصرفي تحت الاسم الشخصي للمستخدم. يرجى الملاحظة (1) السحوبات تخضع لإجراءات السحب في الشركة وقد تخضع لرسوم تحويل اضافية. و (2) أي ربح لم يتم سحبه أو تحويله ونقله إلى حساب التداول وتم استخدامه كهامش لأغراض التداول و /أو لتداول المنتجات المطروحة بدون رافعة مالية في موعد لا يتجاوز 14 يومًا من تاريخ فتح أول معاملة على الحساب التجريبي سيتم الغائه.
        <br><br>
        البونوص متاح فقط للعملاء الجدد والذين سجلوا في منصة الشركة للمرة الأولى، وبعد أن استوفوا جميع معايير الاستحقاق كما هو موضح في أعلاه. بونوص واحد لكل أسرة \ عنوان IP.
        </p>
        <p>
        <b>شروط واحكام عامة</b><br>
        أي إشارة أو اشتباه، وفقا لتقدير الشركة، لأي شكل من الأشكال و\\او وسائل و\\او السلوكيات التجارية الغير المشروعة، والغير عادلة و\\أو المسيئة (بما في ذلك ولكن لا تقتصر على أنماط نشاط التداول التي تشير إلى ذلك بهدف الاستفادة مالياً من بونوص التداول دون أخذ بالحسبان المخاطر في السوق و\\أو عن طريق فتح، تشغيل و\\أو إدارة أكثر من حساب واحد لكل عميل)، وكذلك أي إشارة أو اشتباه في الاحتيال والتلاعب أو خرقاً للاتفاقيات وسياسات وشروط الشركة فيما يتعلق ببرنامج البونوص سيتم إلغاء جميع انواع البونوص التي منحت مسبقاً للحساب وإلى أي حساب اخر ذات صلة. في ظل هذه الظروف، يكون للشركة الحق، وفقاً لتقديرها ودون انتقاص من حقوقها بموجب اتفاقياتها مع العميل والقانون الواجب تطبيقة، لإبطال وإلغاء جميع المعاملات التي و/أو الأرباح و\\أو الخسائر التي حصلت بالحساب، وحظر و\\اومنع كل الحسابات ذات الصلة, ولن تكون الشركة مسؤولة عن أي عواقب لأي من الإجراءات المذكورة.
        <br><br>
        تحتفظ الشركة بالحق ، وفقًا لما تراه مناسبًا ، في تغيير , تعديل , تعليق , إلغاء أو إنهاء أي من المكافآت المذكورة أعلاه ، أو أي جانب من جوانب العرض المذكور أعلاه، في أي وقت تراه مناسب.
        </p>`,
        data_id: "",
        content_after: "",
      },
      {
        //id: "additional_trading_rules",
        id: "tc-view-25",
        title: "شروط تداول اضافية",
        content_before: `
        <b>نداء الهامش</b><br>
        شركة iFOREX لا تقوم في الإغلاق الاجباري لصفقات العملاء ما دام الرصيد ايجابي في حساب العميل. وهذا ما يتيح للعميل الاستغلال التام للرصيد لدعم صفقاتهم المفتوحة ضد تقلبات الاسعار.
        <br><br>
        <b>معلومات الهامش</b><br>
        
        توفر نافذة العرض أدناه معلومات مفصلة تتعلق بهامش الحساب:
        
        <div class="table-wrapper">
        <table class="table3 mt-4 mb-4">
        <tbody><tr>
        <td>الهامش المُستخدم</td>
        <td style="color:red">2,500</td>
        </tr>
        <tr>
        <td>الهامش المُتاح</td>
        <td style="color:green">2,495</td>
        </tr>
        <tr>
        <td>إستغلال الهامش</td>
        <td style="color:green">+50.05٪</td>
        </tr>
        <tr>
        <td>تغطية التعريض</td>
        <td>+0.50٪</td>
        </tr>
        </tbody></table>
        </div>
        <ul class="list-style-disc-small mb-3">
        <li>الهامش المستخدم يظهر مبلغ السيولة في حساب الذي يتم استخدامه حالياً كهامش لصفقاتك المفتوحة. في الحالة التي يكون فيها الهامش المستخدم مساوياً أو أكبر من السيولة، يشير ذلك إلى أنه تم استخدام اقصى حد للرافعة المالية في الحساب. أثناء وحول فترات الاستراحة، يزيد الهامش المطلوب لبعض الأدوات (كما هو مفصل في "جدول تفاصيل المنتج") - وهذا يؤثر على الهامش المتاح، والذي قد ينخفض بشكل كبير خلال عطلة نهاية الأسبوع نتيجة لذلك.<br>الهامش المستخدم = التعريض الصافي لأداة مالية × الهامش المطلوب لتلك الاداة المالية
        </li>
        <li>الهامش المتاح، يظهر مبلغ السيولة في الحساب الذي لم يتم استغلالة وهو متاح لزيادة التعريض الصافي. فيما اذا كان الهامش المتاح يعادل الصفر، فهذا يدل على استغلال اقصى قدر للرافعة المالية في الحساب.<br>لهامش المتاح = السيولة\\ الهامش المستغل
        </li>
        <li>الهامش المستغل يظهر نسبة السيولة التي تستخدم كهامش للصفقات المفتوحة حالياً في الحساب. استخدام واستغلال الهامش بنسبة 100٪ وما فوق، يشير إلى أقصى استخدام للرافعة المالية في الحساب.<br>استغلال الهامش٪ = (الهامش المستخدم / السيولة) × 100
        </li>
        <li>تغطية التعريض، تظهر أي نسبة مؤوية من التعريض الصافي في الحساب مغطاة بواسطة السيولة كضمان ملكية.<br>تغطية التعريض = السيولة\\ التعريض الصافي
        </li>
        </ul>
        <b>التعريض الاقصى</b><br>
        كإجراء تحويطي والذي يهدف إلى إدارة المخاطر بشكل أفضل وتجنب التعرض المفرط لعميل واحد، قد وضعت شركة iFOREX حد أقصى للتعريض الصافي تصل إلى 15 مليون دولار أمريكي للعميل الواحد. شركة iFOREX قد وضعت أيضا حد اقصى للتعريض الصافي لكل اداة مالية. لعرض الحد الأقصى للتعريض الصافي لكل اداة مالية <span class="tclink" target-tab="tc-view-6" target-section="product_section">انقر هنا</span>. شركة iFOREX لها الحق وحسب تقديرها إلغاء أو تغيير هذا الحد في أي لحظة دون أي سابق إنذار.
        <br><br>
        <b>التسييج</b><br>
        يمكن تعريف التسييج على أنه إفتتاح صفقتان على نفس نوع الاداة المالية او الاصل المشتق منه في أتجاهين مختلفين ( واحدة "شراء" والاخرى "بيع") اما في نفس الوقت أو بأوقات مختلفة واما في نفس الكمية أو لا . تعتبر شركة iFOREXمعاملات التسييج لغرض احتساب الحد الأدنى للهامش على أساس تراكمي أو على اساس "صافي". بالاضافة الى ذلك، تعتبر شركة iFOREX إغلاق واحدة من معاملات التسييج كافتتاح عملية جديدة يعادل مبلغها مبلغ المعاملات المتبقية.
        <br><br>
        <b>تصفية الصفقات</b><br>
        في حال هناك حاجة لاغلاق أكثر من صفقة واحدة في نفس الوقت في الحساب، ستقوم شركة iFOREX بإغلاق جميع الصفقات ككتلة واحدة. رقم المعاملة المخصصة لكل صفقة مغلقة محدد حسب قواعد الفيفو (FIFO). وهذا يعني أنه عند اغلاق الصفقة، المركز الذي فتح في الاول سيحصل على أقل رقم للمعاملة والصفقة التي فتحت في النهاية ستحصل على اعلى رقم للمعاملة.
        <br><br>
        <b>ممارسات تجارية غير مرخصة</b><br>
        شركة iFOREX تدعم التداول العادل، ولا تسمح بممارسة تداولات غير عادلة أو غيرها من الممارسات التي تبدي تداولات مسيئة مثل تأخر التداول، التلاعب بالأسعار، التلاعب بالوقت أو أي ممارسات أخرى غير قانونية و/أو تستخدم لإعطاء ميزة غير عادلة للعميل. أمثلة لمثل هذه الممارسات الممنوعة والغير حصرية ممكن أن تكون أي من الإجراءات التالية:
        <ul class="list-style-disc-small mt-3 mb-2">
        <li>
        <b>سكالبينج</b> هي استراتيجية تداول التي تحاول لأن تصنع ارباح عديدة من تغير بسيط بالاسعار. المتداولون الذين ينفذون هذه الاستراتيجية يقومون بإفتتاح كمية صفقات كبيرة ما بين عشرة الى المئات من الصفقات في يوم واحد بإعتقادهم ان التحرك البسيط في السعر سهل المنال من تحركات كبيرة بالاسعار.
        </li>
        <li>
        <b>التشغيل الآلي</b> (مثل EAS) أو التداول حسب خوارزمية وهو استخدام المنصات الإلكترونية لإدخال أوامر للتداول حسب خوارزمية و\\أو معادلات في الرياضيات الذي يتم تنفيذ مبرمج مسبقاً لهذه التعليمات في التداول والتي قد تشمل التوقيت، السعر، أو كمية من الصفقات، أو في كثير من الحالات الشروع في أمر من المتغيرات على يد "روبوت"، من دون تدخل بشري.
        </li>
        <li>
        <b>تداول API</b> هو واجهة برمجة التطبيقات تشير إلى جميع الصفقات التي تستخدم برنامج حاسوبي للتفاعل مع البرامج الأخرى. ال API يعمل باعتباره الوسيط بين المتداول والسوق، وكذلك يكشف الأوامر ويقوم باسترجاع المعلومات عند الحاجة.
        </li>
        <li>
        <b>"الحسابات المتعددة"</b> تشير إلى الحالة الذي يقوم فيها عميل واحد بإنشاء حسابين أو أكثر من أجل الحصول على فوائد متعددة مرتبطة بالحساب من iFOREX.
        </li>
        </ul>
        <p>عندما يكون لدى الشركة أي إشارة أو اشتباه ، وفقًا لتقدير الشركة المطلق ، بشأن أي شكل من أشكال الاستغلال أو ممارسات التداول غير القانونية أو غير العادلة أو غير المصرح بها و / أو المعمول بها ، والتي تُستخدم لمنح العميل ميزة غير عادلة و / أو الاحتيال أو التلاعب أو خرق اتفاقيات الشركة وسياساتها وشروطها وأحكامها ، يكون للشركة الحق ، وفقًا لتقديرها الخاص والمطلق ، ودون الانتقاص من حقوقها بموجب اتفاقياتها مع العميل والقوانين المعمول به ، إبطال وإلغاء جميع المعاملات / الصفقات التي تتم في الحسابات ذات الصلة ، بما في ذلك جميع الأرباح أو الخسائر فيها ، وإزالة أي مكافآت/ بونوصاتممنوحة للعميل و / أو تجميد الحساب.</p>
        <b>خطأ في الاسعار</b><br>
        تكنولوجيا التداول عبر الانترنت غير متكاملة واحياناً وفي حالات نادرة، يمكن أن يحصل عطل في الصفحات. هذا قد يستمر للحظة، ولكن عندما يحصل هذا، من الممكن أن تتأثر الاسعار. في حين أنه من المغري أن تضع "صفقة موازنة"، تذكر في هذه الحالة، أن الاسعار لا تعكس السعر الحقيقي للسوق وأن صفقتك الفعلية من الممكن أن تكون بعيدة بعدة نقاط من السعر المعروض. في حال وتم تنفيذ صفقات في سعر غير معروض على يد شركة iFOREX، الشركة تحتفظ بحقها بإغلاق أي صفقة من هذا النوع لانها تعتبر صفقات غير صالحة. خذ بعين الاعتبار أن هذه الحالات نادرة، وعدم التداول في هذه الحالات يستطيع المتداولين تجنب المخاطرة أذا حدثت هذه السيناريوهات المذكورة اعلاه.
        <br><br>
        <b>رسوم الصيانة</b><br>
        حسابات العملاء والتي لم يكن فيها نشاط تداول لفترة 12 شهر متتالية , قد يتم فرض رسوم صيانة ربع سنوية عليها بقيمة 15$، أو كل قيمة السيولة في الحساب اذا كانت السيولة في الحساب أقل من 15$.
        <br><br>
        <b>رسوم تحويل العملات</b><br>
        إن تداول الأدوات المالية بعملة مختلفة عن عملة حساب تداول العميل قد تفرض رسوم على تحويل العملات.
        <br><br>
        قد تخضع الايداعات أو السحوبات من حساب التداول عن طريق استخدام بطاقة ائتمان بعملة تختلف عن عملة حساب التداول , لرسوم التحويل التي تفرضها شركة بطاقة ائتمان العميل.
        <br><br>
        <b>عدم توفر خدمات التداول وعدم إمكانية الوصول اليها  من بعض البلدان المحظورة </b><br>
        لن تكون منصة التداول و / أو خدمات التداول ممكنة أو متاحة من بعض البلدان المحظورة بما في ذلك ، على سبيل المثال لا الحصر ، الولايات المتحدة الأمريكية. لمزيد من المعلومات حول القيود المفروضة على استخدام أو إمكانية الوصول إلى خدمات الشركة أو موقعها الإلكتروني من بعض البلدان المحظورة ، بما في ذلك قائمة البلدان المحظورة ، يرجى النقر <a href="/legal/restricted-countries" target="_blank" rel="noopener">هنا</a>.
        <br><br>
        للمزيد من المعلومات عن التداول، قم بعرض: <a href="/legal/client_agreement.pdf" target="_blank" rel="noopener">اتفاقية العميل</a>.
        `,
        data_id: "",
        content_after: "",
      },
    ],
  },




  
  {
    id: "forex",
    title: "فوركس",
    tabs: [
      {
        //id: "forex_overnight_financing",
        id: "tc-view-10",
        title: "تمويل ليلي (عمولة التبييت)",
        content_before: `
        عند تداول عقود فروقات الفوركس (Forex CFDs) باستخدام الرافعة المالية في شركة iFOREX، صفقاتك المفتوحة تخضع للتمويل الليلي في نهاية كل يوم تداول. قد يكون هذا التمويل الليلي عرضة للاضافة الى حسابك أو الخصم منه، يتم حسابه على أساس اسعار الفائدة ذات الصلة للعملات التي يتم فيها تداول الصك الأساسي، بالإضافة إلى نسبة الزيادة على التكلفة. إن قيمة التكلفة لأزواج العملات تبدأ من ٪0.75 وترتفع اكثر. كذلك , فأن هذه التكلفة تختلف ما بين صفقات البيع وصفقات الشراء. الرجاء معاينة الجدول أدناه للتعرف على عمولة التبييت المحدّثة.
        <br><br>
        اذا كانت نسبة التمويل الليلي المحسوبة ايجابية، هذا يعني أنه سيتم إضافة المبلغ المطابق (اضافة) إلى رصيد حسابك. نسبة تمويل ليلي سلبية هذا يعني أنه سيتم طرح المبلغ المطابق (خصم) من رصيد حسابك.
        <br><br>
        يمكنك العثور على نسبة التمويل الليلي ذات الصلة، والمبالغ وأوقات تشغيلها الملاءمة على كلٍ من الصفقة ونماذج الحدود، تحت الأدوات، ضمن علامة التبويب "معلومات السوق". لحساب التمويل الليلي، والتي سيتم خصمها او اضافتها الى حسابك، ببساطة قم بعملية ضرب (×) نسبة التمويل الليلي مع حجم صفقتك. عملية التمويل الليلي لكل عقد (CFD) يتم تفصيله في نموذج الصفقة "المعلومات عن الأداة المالية" تحت "التمويل الليلي (GMT)". يتم تطبيق القيمة المحسوبة والنسبة المئوية للتمويل الليلي لفترة يوم واحد. عقود الفروقات التي يتم تداولها 5 أيام في الأسبوع سيتم تزكيتها أو الخصم منها بقيمة 3 أضعاف القيمة المعروضة خلال اليوم الأخير من أسبوع تداول الأصل الأساسي، حيث أنها تغطي فترة نهاية الأسبوع بأكملها. يتم تسعير مبلغ التمويل الليلي وفقاً لعملة العقد (CFD). ومع ذلك، في حالة يكون فيها اختلاف بين عملة سعر العقد والعملة الرئيسية في الحساب، سيتم تحويلها إلى عملة الحساب.
        <br><br>
        <u><b><u>المعادلة</u></b></u><br><br>
        عملية حساب نسبة التمويل الليلي عندما تقوم بعملية شراء:
        <br><br>
        <div class="formula formula_f1">
              <div class="formula-name">نسبة التمويل الليلي</div>
              <div class="formula-equal" >=</div>
              <div class="formula-f1">−
                  <div class="formula-sub">
                      <div class="formula-sub1">متوسط سعر الفائدة 3 اشهر للعملات الاخرى - متوسط سعر الفائدة 3 اشهر للعملة الاساسية + نسبة الزيادة على التكلفة للشراء</div>
                      <div class="formula-sub2">360</div>
                  </div>
              </div>
          </div>
          <br>
        عملية حساب نسبة التمويل الليلي عندما تقوم بعملية بيع:
        <br><br>
        
        <div class="formula formula_f2">
          <div class="formula-name">نسبة التمويل الليلي</div>
          <div class="formula-equal" >=</div>
          <div class="formula-f1">
              <div class="formula-sub">
                  <div class="formula-sub1">متوسط سعر الفائدة 3 اشهر للعملات الاخرى - متوسط سعر الفائدة 3 اشهر للعملة الاساسية - نسبة الزيادة على التكلفة للشراء</div>
                  <div class="formula-sub2">360</div>
              </div>
          </div>
      </div>
                  
                  <br> <br>
        لتحسّب مبلغ التمويل الليلي، ببساطة قم بعملية ضرب (×) النسبة بمبلغ الصفقة:<br><br>مبلغ التمويل الليلي = مبلغ الصفقة × نسبة التمويل الليلي
        <br><br><br>
        <u><b><u>أمثلة</u></b></u><br><br>
        <b>مثال 1</b><br><br>
        هذا مثال عن الحالة التي فيها فرق سعر الفائدة بين البنوك أ<b>على</b> من التكلفة. في مثل هذا الحالات، سيتم الخصم من حسابك عندما تقوم بصفقة شراء واضافة الى حسابك عندما تقوم بصفقة بيع:
        <br><br>
        <ul class="list-style-dashed mb-4">
        <li>الاداة المالية = EUR/USD (اليورو مقابل الدولار الأمريكي)</li>
        <li>EUR (العملة الاساسية) متوسط سعر الفائدة 3 اشهر (السنوي) = ٪0.37 = -0.0037</li>
        <li>الدولار الامريكي (عملة اخرى) متوسط سعر الفائدة 3 اشهر (السنوي) =٪1.08 = 0.0108</li>
        <li>الفرق بأسعار الفائدة بين البنوك = ٪1.45 = 0.0145</li>
        <li>نسبة الزيادة على التكلفة للشراء = ٪0.75 = 0.0075</li>
        <li>نسبة الزيادة على التكلفة للبيع =٪0.75 = 0.0075</li>
        <li>قيمة مبلغ الصفقة المقدر يعملة اخرى = USD 106,550 (100,000 EUR بسعر الاغلاق الحالي 1.0655)</li>
        </ul>
        نسبة التمويل الليلي عندما تقوم بصفقة شراء:<br><br>
        
          <div class="formula formula_f3 mb-2" >
              <div class="formula-name">نسبة التمويل الليلي</div>
              <div class="formula-equal">=</div>
              <div class="formula-f2">0.00611%−</div>
              <div class="formula-equal">=</div>
              <div class="formula-f3">0.0000611−</div>
              <div class="formula-equal" >=</div>
              <div class="formula-f1">−
                  <div class="formula-sub">
                      <div class="formula-sub1">0.0108 − (−0.0037) + 0.0075</div>
                      <div class="formula-sub2">360</div>
                  </div>
              </div>
          </div>

        مبلغ التمويل الليلي = 106,550 × (0.0000611-) = -6.51 USD، ما يعني 6.51 USD دفع لليوم الواحد
        <br><br><br>
        نسبة التمويل الليلي عندما تقوم بصفقة بيع:<br><br>
        
          <div class="formula formula_f4 mb-2" >
              <div class="formula-name">نسبة التمويل الليلي</div>
              <div class="formula-equal">=</div>
              <div class="formula-f2">0.001944%</div>
              <div class="formula-equal">=</div>
              <div class="formula-f3">0.00001944</div>
              <div class="formula-equal" >=</div>
              <div class="formula-f1">
                  <div class="formula-sub">
                      <div class="formula-sub1">0.0108 − (−0.0037) − 0.0075</div>
                      <div class="formula-sub2">360</div>
                  </div>
              </div>
          </div>
    
    
        مبلغ التمويل الليلي = 106,550 × 0.00001944 = 2.07 USD اضافة لكل يوم
        <br><br><br>
        <b>مثال 2</b><br><br>
        هذا مثال عن الحالة التي فيها فرق سعر الفائدة بين البنوك أعلى من نسبة الزيادة على التكلفة، ونسبة الزيادة على التكلفة تختلف بين البيع والشراء. في مثل هذا الحالات، سيتم الخصم من حسابك كل ليلة بغض النظر عن الاتجاه لصفقتك:
        <br><br>
        <ul class="list-style-dashed mb-4">
        <li>الاداة المالية = EUR/TRY (اليورو مقابل الليرة التركية)</li>
        <li>EUR (العملة الاساسية) متوسط سعر الفائدة 3 اشهر (السنوي) = -٪0.37 = -0.0037</li>
        <li>TRY (عملة اخرى) متوسط سعر الفائدة 3 اشهر (السنوي) =٪22.75 = 0.2275</li>
        <li>الفرق بأسعار الفائدة بين البنوك = ٪23.12 = 0.2312</li>
        <li>نسبة الزيادة على التكلفة للشراء = ٪0.75 = 0.0075</li>
        <li>نسبة الزيادة على التكلفة للبيع = ٪14.00 = 0.14</li>
        <li>قيمة مبلغ الصفقة المقدر يعملة اخرى = TRY 620,000 (100,000 EUR بسعر الاغلاق الحالي 6.2000)</li>
        </ul>
        نسبة التمويل الليلي عندما تقوم بصفقة شراء:<br><br>
        
        <div class="formula formula_f5 mb-2" >
              <div class="formula-name">نسبة التمويل الليلي</div>
              <div class="formula-equal">=</div>
              <div class="formula-f2">0.0663%−</div>
              <div class="formula-equal">=</div>
              <div class="formula-f3">0.000663−</div>
              <div class="formula-equal">=</div>
              <div class="formula-f1">−
                  <div class="formula-sub">
                      <div class="formula-sub1">0.2275 − (−0.0037) + 0.0075</div>
                      <div class="formula-sub2">360</div>
                  </div>
              </div>
          </div>

        مبلغ التمويل الليلي = 620,000 × (0.000663-) = -411 TRY، ما يعني 411 TRY دفع لليوم الواحد (≅ 80 USD)
        <br><br><br>
        نسبة التمويل الليلي عندما تقوم بصفقة بيع:<br><br>
        
        <div class="formula formula_f6 mb-2" >
              <div class="formula-name">نسبة التمويل الليلي</div>
              
              <div class="formula-equal">=</div>
              <div class="formula-f2">0.0253%</div>
              <div class="formula-equal">=</div>
              <div class="formula-f3">0.000253</div>
              <div class="formula-equal">=</div>
              <div class="formula-f1">
                  <div class="formula-sub">
                      <div class="formula-sub1">0.2275 − (−0.0037) − 0.14</div>
                      <div class="formula-sub2">360</div>
                  </div>
              </div>
          </div>

        مبلغ التمويل الليلي = 620,000 × 0.000253 = 157 TRY، يعني اضافة 157 ليرة تركية كل يوم (≅30 USD)
        <br><br><br>
        <b>مثال 3</b><br><br>
        هذا مثال عن الحالة التي فيها فرق سعر الفائدة بين البنوك أقل من التكلفة السلبية. في مثل هذا الحالات، سيتم الخصم من حسابك عندما تقوم بصفقة بيع واضافة الى حسابك عندما تقوم بصفقة شراء:
        <ul class="list-style-dashed mt-4 mb-4">
        <li>الاداة المالية = USD/JPY (US Dollar vs. Japanese Yen)</li>
        <li>USD (العملة الاساسية) متوسط سعر الفائدة 3 اشهر (السنوي) = ٪1.08 = 1.08)</li>
        <li>JPY (عملة اخرى) متوسط سعر الفائدة 3 اشهر (السنوي) = -٪0.09 = -0.0009)</li>
        <li>الفرق بأسعار الفائدة بين البنوك = -٪1.17 = -0.0117</li>
        <li>نسبة الزيادة على التكلفة للشراء = ٪0.75 = 0.0075</li>
        <li>نسبة الزيادة على التكلفة للبيع = ٪0.75 = 0.0075</li>
        <li>قيمة مبلغ الصفقة المقدر يعملة اخرى = 10,341,000 JPY (100,000 USD بسعر الاغلاق الحالي103.41)</li>
        </ul>
        نسبة التمويل الليلي عندما تقوم بصفقة شراء:<br><br>

        <div class="formula formula_f7 mb-2" >
              <div class="formula-name">نسبة التمويل الليلي</div>
             
              <div class="formula-equal">=</div>
              <div class="formula-f2">0.001167%</div>
              <div class="formula-equal">=</div>
              <div class="formula-f3">0.00001167</div>
              <div class="formula-equal">=</div>
              <div class="formula-f1">−
                  <div class="formula-sub">
                      <div class="formula-sub1">(−0.0009) − 0.0108 + 0.0075</div>
                      <div class="formula-sub2">360</div>
                  </div>
              </div>
          </div>

        مبلغ التمويل الليلي = 10,341,000 × 0.00001167 = 120.65 JPY اضافة لكل يوم (≅1.1 USD)
        <br><br><br>
        نسبة التمويل الليلي عندما تقوم بصفقة بيع:<br><br>
        
          <div class="formula formula_f8 mb-2" >
              <div class="formula-name">نسبة التمويل الليلي</div>
              
              <div class="formula-equal">=</div>
              <div class="formula-f2">0.00533%−</div>
              <div class="formula-equal">=</div>
              <div class="formula-f3">0.0000533−</div>
              <div class="formula-equal">=</div>
              <div class="formula-f1">
                  <div class="formula-sub">
                      <div class="formula-sub1">(−0.0009) − 0.0108 − 0.0075</div>
                      <div class="formula-sub2">360</div>
                  </div>
              </div>
          </div>

        مبلغ التمويل الليلي = 10,341,000 × (-0.0000533) = 551.52- JPY، ما يعني 551.52 ين ياباني دفع لليوم الواحد (≅5.3 USD)
        <br><br> `,

        data_id: "OvernightFinancing",
        content_after: `<p>* تستغرق تسويات التمويل الليلي مدة تصل الى 15 دقيقة حتى تتم معالجتها في نهاية يوم التداول ، وبعد ذلك سيتم الإضافة أو الخصم على حسابك بطريقة مناسبة`,
        table_titles: [
          "الاداة المالية",
          "نسبة التمويل الليلي بشكل يومي (بيع)",
          "نسبة التمويل الليلي بشكل يومي (شراء)",
          "التمويل الليلي (جرينيتش)*",
        ],
        view_id: ["Forex"],
      },
    ],
  },
  {
    id: "index_commodity_and_crypto_cfds",
    title: "عقود فروقات المؤشرات، السلع والعملات الافتراضية",
    tabs: [
      {
        //id: "index_overnight_financing",
        id: "tc-view-11",
        title: "تمويل ليلي (عمولة التبييت)",
        content_before: `
        عند تداول عقود فروقات على المؤشرات ,السلع والعملات المشفرة (CFD) في شركة iFOREX، صفقاتك المفتوحة تخضع للتمويل الليلي في نهاية كل يوم تداول باستثناء صفقات الشراء للمنتجات بدون الرافعة المالية والتي لا تخضع للتمويل الليلي. قد يكون هذا التمويل الليلي عرضة للاضافة الى حسابك أو الخصم منه، يتم حسابه على أساس اسعار الفائدة ذات الصلة للعملات التي يتم فيها تداول الصك الأساسي، بالإضافة إلى التكلفة. إن المبلغ المضاف إلى سعر التكلفةبالنسبة للعملات الافتراضية\\الرقمية يمكن أن يكون أعلى بكثير بسبب ظروف سوق العملات الافتراضية المتطرفة. يرجى مراجعة الجدول أدناه لمعرفة أحدث قيم التمويل الليلي.
        <br><br>
        اذا كانت نسبة التمويل الليلي المحسوبة ايجابية، هذا يعني أنه سيتم إضافة المبلغ المطابق (اضافة) إلى رصيد حسابك. نسبة تمويل ليلي سلبية هذا يعني أنه سيتم طرح المبلغ المطابق (خصم) من رصيد حسابك.
        <br><br>
        يمكنك العثور على نسبة التمويل الليلي ذات الصلة، والمبالغ وأوقات تشغيلها الملاءمة على كلٍ من الصفقة ونماذج الحدود، تحت الأدوات، ضمن علامة التبويب "معلومات السوق". لحساب التمويل الليلي، والتي سيتم خصمها او اضافتها الى حسابك، ببساطة قم بعملية ضرب (×) نسبة التمويل الليلي مع حجم صفقتك. عملية التمويل الليلي لكل عقد (CFD) يتم تفصيله في نموذج الصفقة "المعلومات عن الأداة المالية" تحت "التمويل الليلي (GMT)". يتم تطبيق القيمة المحسوبة والنسبة المئوية للتمويل الليلي لفترة يوم واحد. عقود الفروقات التي يتم تداولها 5 أيام في الأسبوع سيتم تزكيتها أو الخصم منها بقيمة 3 أضعاف القيمة المعروضة خلال اليوم الأخير من أسبوع تداول الأصل الأساسي، حيث أنها تغطي فترة نهاية الأسبوع بأكملها. يتم تسعير مبلغ التمويل الليلي وفقاً لعملة العقد (CFD). ومع ذلك، في حالة يكون فيها اختلاف بين عملة سعر العقد والعملة الرئيسية في الحساب، سيتم تحويلها إلى عملة الحساب.
        <br><br>
        <u><b><u>المعادلة</u></b></u><br><br>
        عملية حساب نسبة التمويل الليلي عندما تقوم بعملية شراء:<br><br>
        
          <div class="formula formula_f9 mb-2">
              <div class="formula-name">نسبة التمويل الليلي</div>
              <div class="formula-equal" >=</div>
              <div class="formula-f1">−
                  <div class="formula-sub">
                      <div class="formula-sub1">سعر الفائدة 3 اشهر + تكلفة</div>
                      <div class="formula-sub2">360</div>
                  </div>
              </div>
          </div>
          <br>
        عملية حساب نسبة التمويل الليلي عندما تقوم بعملية بيع:<br><br>
        
          <div class="formula formula_f10 mb-2">
              <div class="formula-name">نسبة التمويل الليلي</div>
              <div class="formula-equal" >=</div>
              <div class="formula-f1">
                  <div class="formula-sub">
                      <div class="formula-sub1">سعر الفائدة 3 اشهر - تكلفة</div>
                      <div class="formula-sub2">360</div>
                  </div>
              </div>
          </div>

        لتحسّب مبلغ التمويل الليلي، ببساطة قم بعملية ضرب (×) النسبة بمبلغ الصفقة:<br><br>مبلغ التمويل الليلي = مبلغ الصفقة × نسبة التمويل الليلي
        <br><br><br>
        <u><b><u>أمثلة</u></b></u><br><br>
        <b>مثال 1</b><br><br>
        هذا مثال عن الحالة التي فيها فرق سعر الفائدة بين البنوك أ<b>على</b> من التكلفة. في مثل هذا الحالات، سيتم الخصم من حسابك عندما تقوم بصفقة شراء واضافة الى حسابك عندما تقوم بصفقة بيع:
        <br><br>
        <ul class="list-style-dashed mb-4">
        <li>الاداة المالية = Brazil Ibovespa</li>
        <li>الريال البرازيلي (BRL) سعر الفائدة 3 اشهر (السنوي) = ٪9.567 = 0.09567</li>
        <li>تكلفة = ٪2.5 = 0.025</li>
        <li>قيمة مبلغ الصفقة المقدر بالعملة = 127,380 BRL (2 عقود مؤشرات بسعر الاغلاق الحالي 63690 BRL للعقد)</li>
        </ul>
 
        نسبة التمويل الليلي عندما تقوم بصفقة شراء:<br><br>
        
          <div class="formula formula_f11 mb-2">
              <div class="formula-name">نسبة التمويل الليلي</div>
              
              <div class="formula-equal">=</div>
              <div class="formula-f2">0.03351944%−</div>
              <div class="formula-equal">=</div>
              <div class="formula-f3">0.0003351944−</div>
              <div class="formula-equal" >=</div>
              <div class="formula-f1">−
              <div class="formula-sub">
                  <div class="formula-sub1">0.09567 + 0.025</div>
                  <div class="formula-sub2">360</div>
              </div>
          </div>
          </div>

        مبلغ التمويل الليلي = 127,380 × (-0.0003351944) = -42.70 BRL, ما يعني 42.70 BRL دفع لليوم الواحد (≅13.58 USD)
        <br><br><br>
        نسبة التمويل الليلي عندما تقوم بصفقة بيع:<br><br>
        
              <div class="formula formula_f12 mb-2">
                  <div class="formula-name">نسبة التمويل الليلي</div>
                  
                  <div class="formula-equal">=</div>
                  <div class="formula-f2">0.019630556%</div>
                  <div class="formula-equal">=</div>
                  <div class="formula-f3">0.00019630556</div>
                  <div class="formula-equal" >=</div>
                  <div class="formula-f1">
                      <div class="formula-sub">
                          <div class="formula-sub1">0.09567 − 0.025</div>
                          <div class="formula-sub2">360</div>
                      </div>
                  </div>
              </div>

        مبلغ التمويل الليلي = 127,380 × 0.00019630556 = 25 BRL اضافة لكل يوم (≅7.95 USD)
        <br><br><br>
        <b>مثال 2</b><br><br>
        هذا مثال عن الحالة التي فيها فرق سعر الفائدة بين البنوك أ<b>قل</b> من التكلفة. في مثل هذا الحالات، سيتم الخصم من حسابك كل ليلة بغض النظر عن الاتجاه لصفقتك:
        <br><br>
        <ul class="list-style-dashed mb-4">
        <li>الاداة المالية = Oil (النفط الخام الخفيف WTI)</li>
        <li>الدولار الامريكي (USD) سعر الفائدة 3 اشهر (السنوي) =٪1.08 = 0.0108</li>
        <li>تكلفة = ٪2.5 = 0.025</li>
        <li>قيمة مبلغ الصفقة المقدر بالعملة = USD 53,250 (1,000 برميل نفط بسعر الاغلاق الحالي USD 53.25 للبرميل)</li>
        </ul>

        نسبة التمويل الليلي عندما تقوم بصفقة شراء:<br><br>
        
          <div class="formula formula_f13 mb-2">
              <div class="formula-name">نسبة التمويل الليلي</div>
              
              <div class="formula-equal">=</div>
              <div class="formula-f2">0.009944%−</div>
              <div class="formula-equal">=</div>
              <div class="formula-f3">0.00009944−</div>
              <div class="formula-equal">=</div>
              <div class="formula-f1">−
                  <div class="formula-sub">
                      <div class="formula-sub1">0.0108 + 0.025</div>
                      <div class="formula-sub2">360</div>
                  </div>
              </div>
          </div>

        مبلغ التمويل الليلي = 53,250 × (-0.00009944) = -5.30 USD, ما يعني 5.30 USD دفع لليوم الواحد
        <br><br><br>
        نسبة التمويل الليلي عندما تقوم بصفقة بيع:<br><br>
        
          <div class="formula formula_f14 mb-2">
              <div class="formula-name">نسبة التمويل الليلي</div>
              
              <div class="formula-equal">=</div>
              <div class="formula-f2">0.003944%−</div>
              <div class="formula-equal">=</div>
              <div class="formula-f3">0.00003944−</div>
              <div class="formula-equal">=</div>
              <div class="formula-f1">
                  <div class="formula-sub">
                      <div class="formula-sub1">0.0108 − 0.025</div>
                      <div class="formula-sub2">360</div>
                  </div>
              </div>
          </div>

        مبلغ التمويل الليلي = 53,250 × (-0.00003944) = -2.10 USD, ما يعني 2.10 USD دفع لليوم الواحد
        <br><br>
        `,
        data_id: "OvernightFinancing",
        content_after: `<p>* تستغرق تسويات التمويل الليلي مدة تصل الى 15 دقيقة حتى تتم معالجتها في نهاية يوم التداول ، وبعد ذلك سيتم الإضافة أو الخصم على حسابك بطريقة مناسبة`,
        table_titles: [
          "الاداة المالية	",
          "نسبة التمويل الليلي بشكل يومي (بيع)",
          "نسبة التمويل الليلي بشكل يومي (شراء)",
          "التمويل الليلي (جرينيتش)*",
        ],
        view_id: ["Index", "Commodity", "Crypto"],
      },
      {
        //id: "contracts_rollover_dates",
        id: "tc-view-3",
        title: "مواعيد تمديد العقود",
        content_before: `<p>
                          كل العقود مقابل الفروقات (CFD) التي تستند على العقود المستقبلية (مثال: السلع والمؤشرات) لها تاريخ تمديد.
                          <br><br>
                          عند بلوغ موعد تمديد الصك ذا الصلة، جميع مراكز صفقات العقود مقابل الفروقات المستقبلية سيتم تمديدها الى موعد العقد القادم، بحيث تبقى المراكز مفتوحة مع العقد المستقبلي الجديد.
                          <br><br>
                          على تفعيل هذا التمديد، الربح\\الخسارة للصفقات المفتوحة سوف تُعبر عن فرق السعر بين أسعار العقود منتهية الصلاحية والعقود الجديدة، وكذلك تشمل تكلفة السبريد. يتم تعديل جميع طلبات اوامر الحدود المرتبطة بها تلقائياً وفقاً لسعر العقد المستقبلي الجديد.
                          <br><br>
                          على سبيل المثال، إذا كان آخر سعر لعقد نفط خام غرب تكساس الوسيط (WTI) في شهر فبراير-شباط هو 50.125 دولار امريكي وسعر السوق للعقد التالي (شهر مارس-اذار) في ذلك الوقت هو 50.805$، اذاً سيتم تحديث مستوى الأسعار لجميع أوامر الحدود المعلقة، ارتفاع بمقدار 0.68$
                          <br><br>
                          مواعيد التمديد للعقود تعتمد على الاداة المالية التي تتداولها، وتلك المذكورة ادناه يجب ان تكون المواعيد الوحيدة للتمديد التي تنطبق على العقود مقابل الفروقات في شركة iFOREX:
                          </p>`,

        data_id: "FuturesRollover",
        content_after: ``,
        table_titles: ["عقد شهري", "تمديد العقد (جرينتش)"],
        view_id: ["Commodity", "Index"],
        products: ["السلع", "المؤشرات"],
      },
    ],
  },
  {
    id: "Share and ETF CFDs",
    title: "عقود الفروقات على الأسهم و صناديق الاستثمار المتداولة",
    tabs: [
      {
        //id: "shares_overnight_financing",
        id: "tc-view-12",
        title: "تمويل ليلي (عمولة التبييت)",
        content_before: `
        عند تداول عقود الفروقات على الأسهم و صناديق الاستثمار المتداولة مع شركة iFOREX ، تخضع صفقاتك المفتوحة للتمويل الليلي في نهاية كل يوم تداول ، باستثناء صفقات الشراء للمنتجات بدون الرافعة المالية والتي لا تخضع للتمويل الليلي . قد يضاف هذا التمويل الليلي الى الحساب أو يخصم منه ، والذي يكون محسوبًا على أساس أسعار الفائدة ذات الصلة للعملات التي يتم تداول الأداة الأساسية بها ، بالإضافة إلى نسبة التكلفة المضافة (mark up). يرجى مراجعة الجدول أدناه لمعرفة أحدث قيم التمويل الليلي.
        <br><br>
        اذا كانت نسبة التمويل الليلي المحسوبة ايجابية، هذا يعني أنه سيتم إضافة المبلغ المطابق (اضافة) إلى رصيد حسابك. نسبة تمويل ليلي سلبية هذا يعني أنه سيتم طرح المبلغ المطابق (خصم) من رصيد حسابك.
        <br><br>
        يمكنك العثور على نسبة التمويل الليلي ذات الصلة، والمبالغ وأوقات تشغيلها الملاءمة على كلٍ من الصفقة ونماذج الحدود، تحت الأدوات، ضمن علامة التبويب "معلومات السوق". لحساب التمويل الليلي، والتي سيتم خصمها او اضافتها الى حسابك، ببساطة قم بعملية ضرب (×) نسبة التمويل الليلي مع حجم صفقتك. عملية التمويل الليلي لكل عقد (CFD) يتم تفصيله في نموذج الصفقة "المعلومات عن الأداة المالية" تحت "التمويل الليلي (GMT)". يتم تطبيق القيمة المحسوبة والنسبة المئوية للتمويل الليلي لفترة يوم واحد. عقود الفروقات التي يتم تداولها 5 أيام في الأسبوع سيتم تزكيتها أو الخصم منها بقيمة 3 أضعاف القيمة المعروضة خلال اليوم الأخير من أسبوع تداول الأصل الأساسي، حيث أنها تغطي فترة نهاية الأسبوع بأكملها. يتم تسعير مبلغ التمويل الليلي وفقاً لعملة العقد (CFD). ومع ذلك، في حالة يكون فيها اختلاف بين عملة سعر العقد والعملة الرئيسية في الحساب، سيتم تحويلها إلى عملة الحساب.
        <br><br>
        <u><b><u>المعادلة</u></b></u><br><br>
        عملية حساب نسبة التمويل الليلي عندما تقوم بعملية شراء:<br><br>
        
          <div class="formula formula_f15 mb-2">
              <div class="formula-name">نسبة التمويل الليلي</div>
              <div class="formula-equal" >=</div>
              <div class="formula-f1">−
                  <div class="formula-sub">
                      <div class="formula-sub1">سعر الفائدة 3 اشهر + تكلفة</div>
                      <div class="formula-sub2">360</div>
                  </div>
              </div>
          </div>
          <br>
        عملية حساب نسبة التمويل الليلي عندما تقوم بعملية بيع:<br><br>
        
              <div class="formula formula_f16 mb-2">
                  <div class="formula-name">نسبة التمويل الليلي</div>
                  <div class="formula-equal" >=</div>
                  <div class="formula-f1">
                      <div class="formula-sub">
                          <div class="formula-sub1">سعر الفائدة 3 اشهر - تكلفة</div>
                          <div class="formula-sub2">360</div>
                      </div>
                  </div>
              </div>

        لتحسّب مبلغ التمويل الليلي، ببساطة قم بعملية ضرب (×) النسبة بمبلغ الصفقة:<br><br>مبلغ التمويل الليلي = مبلغ الصفقة × نسبة التمويل الليلي
        <br><br><br>
        <u><b><u>أمثلة</u></b></u><br><br>
        <b>مثال 1</b><br><br>
        هذا مثال عن الحالة التي فيها فرق سعر الفائدة بين البنوك أ<b>على</b> من التكلفة. في مثل هذا الحالات، سيتم الخصم من حسابك عندما تقوم بصفقة شراء واضافة الى حسابك عندما تقوم بصفقة بيع:
        <br><br>
        <ul class="list-style-dashed mb-4">
        <li>الاداة المالية = Gazprom (GAZP)</li>
        <li>الروبل الروسي (RUB) سعر الفائدة 3 اشهر (السنوي) =٪9.5 = 0.095</li>
        <li>تكلفة = ٪5 = 0.05</li>
        <li>قيمة مبلغ الصفقة المقدر بالعملة = 2,459,000 RUB (20,000 سهم بسعر الاغلاق الحالي 122.95 RUB للسهم)</li>
        </ul>
        نسبة التمويل الليلي عندما تقوم بصفقة شراء:<br><br>
        
              <div class="formula formula_f17 mb-2">
                  <div class="formula-name">نسبة التمويل الليلي</div>
                  <div class="formula-equal">=</div>
                  <div class="formula-f2">0.04%−</div>
                  <div class="formula-equal">=</div>
                  <div class="formula-f3">0.0004−</div>
                  <div class="formula-equal" >=</div>
                  <div class="formula-f1">−
                  <div class="formula-sub">
                      <div class="formula-sub1">0.095 + 0.05</div>
                      <div class="formula-sub2">360</div>
                  </div>
              </div>
              </div>

        مبلغ التمويل الليلي = 2,459,000 × (-0.0004) = -983.60 RUB ما يعني 983.60 RUB دفع لليوم الواحد (≅17.52 USD)
        <br><br><br>
        نسبة التمويل الليلي عندما تقوم بصفقة بيع:<br><br>
        
              <div class="formula formula_f18 mb-2">
                  <div class="formula-name">نسبة التمويل الليلي</div>
                  <div class="formula-equal">=</div>
                  <div class="formula-f2">0.0125%</div>
                  <div class="formula-equal">=</div>
                  <div class="formula-f3">0.000125</div>
                  <div class="formula-equal" >=</div>
                  <div class="formula-f1">
                      <div class="formula-sub">
                          <div class="formula-sub1">0.095 - 0.05</div>
                          <div class="formula-sub2">360</div>
                      </div>
                  </div>
              </div>

        مبلغ التمويل الليلي = 2,459,000 × 0.000125 = 307.38 RUB اضافة لكل يوم (≅5.48 USD)
        <br><br><br>
        <b>مثال 2</b><br><br>
        هذا مثال عن الحالة التي فيها فرق سعر الفائدة بين البنوك أقل من التكلفة. في مثل هذا الحالات، سيتم الخصم من حسابك كل ليلة بغض النظر عن الاتجاه لصفقتك:<br>
        <br><br>
        <ul class="list-style-dashed mb-4">
        <li>الاداة المالية = Apple (AAPL)</li>
        <li>الدولار الامريكي (USD) سعر الفائدة 3 اشهر (السنوي) =٪1.08 = 0.0108</li>
        <li>تكلفة = ٪5 = 0.05</li>
        <li>قيمة مبلغ الصفقة المقدر بالعملة = USD 70,600 (500 سهم بسعر الاغلاق الحالي USD 141.20 للسهم)</li>
        </ul>
  
        نسبة التمويل الليلي عندما تقوم بصفقة شراء:<br><br>
        
          <div class="formula formula_f19 mb-2">
              <div class="formula-name">نسبة التمويل الليلي</div>
              <div class="formula-equal">=</div>
              <div class="formula-f2">0.0169%−</div>
              <div class="formula-equal">=</div>
              <div class="formula-f3">0.000169−</div>
              <div class="formula-equal">=</div>
              <div class="formula-f1">−
                  <div class="formula-sub">
                      <div class="formula-sub1">0.0108 + 0.05</div>
                      <div class="formula-sub2">360</div>
                  </div>
              </div>
          </div>

        مبلغ التمويل الليلي = 70,600 × (-0.000169)= -11.93, ما يعني 11.93 USD دفع لليوم الواحد
        <br><br><br>
        نسبة التمويل الليلي عندما تقوم بصفقة بيع:<br><br>
        
              <div class="formula formula_f20 mb-2">
                  <div class="formula-name">نسبة التمويل الليلي</div>
                  <div class="formula-equal">=</div>
                  <div class="formula-f2">0.0109%−</div>
                  <div class="formula-equal">=</div>
                  <div class="formula-f3">0.000109−</div>
                  <div class="formula-equal">=</div>
                  <div class="formula-f1">
                      <div class="formula-sub">
                          <div class="formula-sub1">0.0108 - 0.05</div>
                          <div class="formula-sub2">360</div>
                      </div>
                  </div>
              </div>

        مبلغ التمويل الليلي = 70,600 × (-0.000109) = -7.70 USD, ما يعني 7.70 USD دفع لليوم الواحد
        <br><br>
        `,
        data_id: "OvernightFinancing",
        content_after: `<p>* تستغرق تسويات التمويل الليلي مدة تصل الى 15 دقيقة حتى تتم معالجتها في نهاية يوم التداول ، وبعد ذلك سيتم الإضافة أو الخصم على حسابك بطريقة مناسبة</p>`,
        table_titles: [
          "الاداة المالية",
          "نسبة التمويل الليلي بشكل يومي (بيع)",
          "نسبة التمويل الليلي بشكل يومي (شراء)",
          "التمويل الليلي (جرينيتش)*",
        ],
        view_id: [ "Shares", "ETF"],
      },
      {
        //id: "dividends",
        id: "tc-view-7",
        title: "توزيع الارباح",
        content_before: `<p>
                  في حال وجود توزيع أرباح نقدية فيما يتعلق باسهم العقود مقابل الفروقات (share CFD) ، سوف يتم تعديل الأرباح إلى رصيد العميل مع الاخذ بعين الاعتبار صفقات الاسهم والعقود ذات الصلة التي قام بها العميل في نهاية يوم العمل الذي يسبق تاريخ موعد توزيع الارباح. تعديل الأرباح يجب ان يتم حسابه على أساس حجم الأرباح، وحجم صفقات العميل وعلى اساس اذا كانت عملية شراء أو بيع، حيث ان في صفقة الشراء يجب ان يكون التعديل اضافة لرصيد العميل وفي صفقات البيع يجب ان يكون التعديل خصم من رصيد العميل. الأرباح يجب ان يتم خصمها او اضافتها من\\الى رصيد العملاء ليس في ساعات تداول السهم الأساسي ذات الصلة وقبل افتتاح يوم التداول التالي للسهم، وهي تكون مشروطة بالصفقات ذات الصلة التي لدى العميل في وقت تعديل الأرباح. خلال هذه الفترة، وذلك للحفاظ على القيمة العادلة لسيولة العميل حتى افتتاح يوم التداول التالي، يجب على الشركة تعديل مراكز وصفقات العميل وفقاً لمبلغ الأرباح التي تم خصمها أو اضافتها من\\الى رصيد العميل.  
                  <br><br>
                  <u>مثال:</u><br>
                  شركة كوكا كولا تقوم بتوزيع أرباح بقيمة 0.35 دولار أمريكي للسهم الواحد.<br>
                  التاريخ ما قبل توزيع الارباح هو 29 نوفمبر-تشرين ثاني وتاريخ التسوية في شركة iFOREX هو 28 نوفمبر-تشرين ثاني في الساعة 22:05 بتوقيت جرينتش.<br>
                  سعر الاغلاق قبل التسوية هو 41.65.<br>
                  العميل الذي لدية صفقة شراء بقيمة 5000 سهم سوف يحصل على اضافة مبلغ 0.35$ × 5000 = 1750$ اذا كانت صفقته مفتوحة في موعد التسوية.<br>
                  إذا كان لدى العميل صفقة بيع ، فسيتم خصم مبلغ مماثل من رصيد حساب التداول لهذا العميل.<br>
                  سعر السهم سيتم تعديلة خلال ساعات بعد الدوام من قيمة 41.65 الى قيمة 41.30 والذي يساوي اخر سعر للسهم مطروح منه مبلغ الارباح.
                  </p>`,
        data_id: "CorporateActions",
        content_after: "",
        no_information:"لا توجد حاليا معلومات عن توزيعات الأرباح المستقبلية",
        table_titles: [
          "سهم مالي / ETF",
          "السوق",
          "مبلغ الارباح",
          "التاريخ واليوم (جرينتش)",
        ],
        view_id: "1",
      },
      {
         //id: "corporate_actions",
         id: "tc-view-1",
        title: "تجزئة الأسهم وإجراءات الشركة الأخرى",
        content_before: `<p>
          إعلانات الشركة او احداث الشركة هي احداث معيّنة التي من الممكن أن تؤثر على قيمة أسهم الشركة. ما لم يذكر خلاف ذلك أدناه فيما يتعلق بإجراءات الشركات المحددة ، عند اعلان حدث شركة على سهم معين، يتوجب على شركة iFOREX تسييل اي صفقة\\صفقات مفتوحة وإزالة أي امر لحد على العقود مقابل الفروقات الذي يقتبس السهم المعين.
          <br><br>
          اعلانات الشركة في شركة iFOREX تشمل طرح الحقوق،طلب إلغاء إدراج واي حدث أو اعلان أخر الذي قد يؤثر مادياً أو يؤثر بشكل جوهري على سعر ألاسهم (بما في ذلك إعلانات الشركة المادية والاقتصادية، عمليات الاستحواذ والاندماج والإفلاس الخ......).
          <br><br>
          <strong>قوانين تجزئة الأسهم وتجزئة الأسهم العكسية</strong><br>
          لا تؤدي تجزئة الأسهم وتجزئة الأسهم العكسية في البورصة إلى تغيير القيمة الإجمالية للأسهم لأولئك الذين يمتلكونها ، بل تغير عدد الأسهم وسعرها. عادة ما يتم تنفيذ هذه التقسيمات عندما يكون سعر السهم مرتفعا جدا أو منخفضا جدا. إذا واجهت صفقة مفتوحة / حد عملية تجزئة الأسهم ، سيتم تعديل حجم الصفقة والاسعار والاوامر (حدود) المرتبطة بتلك العملية (بما في ذلك رصيد الحساب ، بسبب تعديلات ربح/خسارة المطلوبة ، إن وجدت).
          <br><br>
          على سبيل المثال ، في عملية تجزئة أسهم بنسبة 1:10 ، سيتم تحويل سهم واحد الى 10 أسهم بعد حدوث عملية التجزئة وبالتالي يتم تقسيم السعر على 10 ، تاركا القيمة الإجمالية للأسهم دون تغيير. على سبيل المثال ، اذا كان قيمة سهم واحد بسعر 1000 دولار , سيصبح بعد عملية التجزئة 10 أسهم بسعر 100 دولار بعد الحدث: 1x 1000 دولار = 10 × 100 دولار = قيمة 1000 دولار.
          <br><br>
          تجدون أدناه قائمة من أحداث واعلانات الشركات المقبلة:
            </p>`,
        data_id: "CorporateActions",
        content_after: "",
        no_information:"هنا، في هذه المرحلة لا يوجد معلومات عن اجراءات مستقبلية للشركة",
        table_titles: ["سهم مالي / ETF", "السوق", "النوع", "التاريخ واليوم (جرينتش)"],
      },
      {
        //id: "earnings_reports",
        id: "tc-view-22",
        title: "تقارير الأرباح",
        content_before: `<p>
        
                  تقرير الأرباح هو ملف دوري تقدمه الشركات العامة للإبلاغ عن أدائها. من خلال تحليل تقارير الأرباح الفصلية ، يمكن للمستثمرين قياس القدرة المالية للشركة. يمكن أن يؤثر الإعلان عن أرباح الشركة ، خاصة بالنسبة للشركة ذات القيمة السوقية المرتفعة ، على أسعار أسهمها ، مما قد يتسبب في تقلبها على نطاق واسع في الأيام التي يتم فيها إصدار تقارير الأرباح الفصلية هذه.
                  <br><br>
                  لهذا السبب ، سيتم تعديل الحد الأقصى لمتطلبات التعرض والهامش للأسهم ذات الصلة خلال فترة النشر. سيتم تخفيض الحد الأقصى للتعرض للسهم الواحد إلى 50000 دولار ، وستتضاعف متطلبات الهامش.
                  <br><br>
                  للاطلاع على جدول تقارير أرباح كل شركة، يرجى فتح التطبيق على الجوال والانتقال إلى علامة التبويب "معلومات" ضمن شاشة التداول للشركة المحددة. ستجد هنا، ضمن "الأحداث القادمة"، تاريخ تقرير الأرباح القادم.
       
        </p>`,
        data_id: "",
        content_after: "",
      },
    ],
  },
];

export { content };
